import { SubCategoriesDto } from './subcategorydto';
import { TextTransform } from '../../../ui/toolkit/texttransform/texttransform';

export interface CategoryDto
{
    getId(): string;
    getTitle(): string;
    getImgPath(): string;
    getLanguage(): string;
    getSubCategoriesList() : SubCategoriesDto[];
}

export class CategoryDtoImpl implements CategoryDto
{
    private id: string;
    private title: string;
    private imgPath: string;
    private language: string;
    private subCategoriesList: SubCategoriesDto[];

    
    getSubCategoriesList(): SubCategoriesDto[]
    {
        return this.subCategoriesList;
    }
    setSubCategoriesList(subCategoriesList: SubCategoriesDto[])
    {
        this.subCategoriesList = subCategoriesList;
    }

    setId(id: string)
    {
        this.id = id;
    }
    
    setTitle(title: string)
    {
        this.title = TextTransform.convertToCaptialize(title);
    }

    setImgPath(imgPath: string)
    {
        this.imgPath = imgPath;
    }

    getTitle(): string 
    {
        return this.title;
    }    

    getImgPath(): string 
    {
        return this.imgPath;
    }

    getId(): string 
    {
       return this.id;
    }

    getLanguage(): string 
    {
        return this.language;
    }
    setLanguage(language: string)
    {
        this.language = language;
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/core/dto/categories/categorydto.ts